// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ScheduledJobs_ToggleInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ScheduledJobs_ToggleInput — body for POST /scheduled-jobs/toggle.
 *
 * The quick enable/disable flip used by the console's list-row switch
 * (distinct from a full ScheduledJobs_SaveInput edit) — this is also the
 * exact action the S10 sweep-transition PASSO 3 flip relies on
 * (docs/billing-uplift-decision-log.md § S10 TRANSIÇÃO DO SWEEP).
 */
import { registerContract } from './validate'

export interface ScheduledJobs_ToggleInput {
id: number
enabled: boolean
}

registerContract('ScheduledJobs_ToggleInput', {
  id:      { type: 'number',  required: true },
  enabled: { type: 'boolean', required: true },
})
